// this is an autogenerated file from App/Account/Content/Settings/Content/Onboarding/DiscountChargesCorrections/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Onboarding_DiscountChargesCorrections($location_ids: [uuid!]!) {
  result: onboarding_inputs_discounts_charges_corrections(
    location_ids: $location_ids
  ) {
    ok
  }
}

`